import React from 'react';
import { Alert } from '../../platformui';
import { sortByDate } from './accordion-helpers';
import AccordionItem from './accordion-item';

const Accordion = ({ props, type }) => {
  const alertMessage =
    type === 'Ended' ? 'avslutade driftstörningar' : 'servicefönster';

  const sortedProps = sortByDate(props, type);

  return (
    <div className="accordion__container">
      {props?.length !== 0 ? (
        <>
          {sortedProps.map((item, index) => (
            <AccordionItem
              key={index}
              ServiceName={item.ServiceName}
              Begin={item.Begin}
              End={item.End}
              Details={item.Details}
              type={type}
            />
          ))}
        </>
      ) : (
        <Alert
          AlertDescription={`Just nu finns inga ${alertMessage}`}
          type="info"
          Modifiers={{ 'c-alert--small': true, 'c-alert__status-info': true }}
        >
          {<div>{`Just nu finns inga ${alertMessage}.`}</div>}
        </Alert>
      )}
    </div>
  );
};

export default Accordion;
